import { render, staticRenderFns } from "./branchList.vue?vue&type=template&id=27ce1f68"
import script from "./branchList.js?vue&type=script&lang=js&external"
export * from "./branchList.js?vue&type=script&lang=js&external"
import style0 from "./branchList.vue?vue&type=style&index=0&id=27ce1f68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports